import * as React from 'react';

import { useDevice, useWindowSize } from '../hooks.tsx';

import './menu-wrapper.css';

interface MenuWrapper extends React.HTMLAttributes<HTMLDivElement> {
  header: React.ReactNode;
  footer: React.ReactNode;
  open: boolean;
  onToggle: () => void;
}

const MenuWrapper = React.forwardRef<HTMLDivElement, MenuWrapper>(
  ({ header, footer, open = false, onToggle, children, ...props }, ref) => {
    const dimensions = useWindowSize();
    const device = useDevice(dimensions);

    return device === 'desktop' ? (
      <div className="menu-wrapper" ref={ref} {...props}>
        <div className="menu-wrapper-header">{header}</div>
        <div className="menu-wrapper-list">{children}</div>
        <div className="menu-wrapper-footer">{footer}</div>
      </div>
    ) : (
      // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
      <div
        className={`menu-wrapper-hamburger menu-wrapper-hamburger-${
          open ? 'open' : 'closed'
        }`}
        ref={ref}
        onClick={onToggle}
      >
        <div
          className={`menu-wrapper-hamburger-slide menu-wrapper-hamburger-slide-${
            open ? 'open' : 'closed'
          }`}
          {...props}
        >
          <div className="menu-wrapper-header">{header}</div>
          <div className="menu-wrapper-list">{children}</div>
        </div>
      </div>
    );
  },
);

export { MenuWrapper };
